import Sizeable from "./Sizeable";

export default {

    mixins: [Sizeable],

    computed: {
        textSizeString() {
            if (this.size === '3xs') {
                return 'text-3xs';
            }
            if (this.xxSmall || this.size === '2xs') {
                return 'text-2xs';
            }

            if (this.xSmall || this.size === 'xs') {
                return 'text-xs';
            }

            if (this.small || this.size === 'sm') {
                return 'text-sm';
            }

            if (this.medium || this.size === 'md') {
                return 'text-md';
            }

            if (this.large || this.size === 'lg') {
                return 'text-lg';
            }

            if (this.xLarge || this.size === 'xl') {
                return 'text-xl';
            }

            if (this.xxLarge || this.size === '2xl') {
                return 'text-2xl';
            }

            return null;
        }
    }
}
